import CommonService from '../../services/common'
import i18n from "../../i18n";
import { buildAudienceFieldMap, getAudienceSummaryBullets, enrichAudienceSummaryContext } from '../../helpers/audienceSummary';

const multiValueTextOperators = () => ([
  {"label" : i18n.t("audiences.audience_conditions_contains_any"), "id" : "like_any"},
  {"label" : i18n.t("audiences.audience_conditions_no_contains_any"), "id" : "not_like_any"},
  {"label" : i18n.t("audiences.audience_conditions_equal_any"), "id" : "in"},
  {"label" : i18n.t("audiences.audience_conditions_not_equal_any"), "id" : "not_in"},
])

export const state = {}

export const mutations = {}


export const getters = {}

export const actions = {
  // This is automatically run in `src/state/store.js` when the app
  // starts, along with any other actions named `init` in other modules.
  // eslint-disable-next-line no-unused-vars
  init({ state, dispatch }) {},

  // eslint-disable-next-line no-unused-vars
  uploadMedia({commit},payload) {
    return new Promise((resolve, reject) => {
      CommonService.addBucket(payload).then(response => {
          
          if (response.data) {
              resolve(response.data)
          } else {
              reject({message: ''})
          }
      }).catch(error => { reject(error) })
    })
  },

  // eslint-disable-next-line no-unused-vars
  getNews ({ commit },params) {
    return new Promise((resolve, reject) => { 
      CommonService.getNews(params).then(response=> {
        resolve(response.data)
    })
    .catch(error=>{ reject(error) })
    });
  },

  // requires: sin ese dato discover devuelve vacío (product = PDP, customer = customer logueado).
  // uses: lo aprovecha si está; sin él cae a popularidad. params: dato extra de la estrategia.
  // Lo usa el probador de recomendaciones para avisar antes de ejecutar.
  // eslint-disable-next-line no-unused-vars
  getRecommendationStrategies({ commit }){
    return [
      {
        id: "user_reco",
        name: i18n.t('personalizations.experience_variable_strategy_user_reco'),
        uses: ['customer'],
      },
      {
        id: "collaborative",
        name: i18n.t('personalizations.experience_variable_strategy_collaborative'),
        requires: ['customer'],
      },
      {
        id: "similarity",
        name: i18n.t('personalizations.experience_variable_strategy_similarity'),
        requires: ['product'],
        pages_restricted: ['cart', 'checkout', 'category','home','product_listing']
      },
      {
        id: "fbt",
        name: i18n.t('personalizations.experience_variable_strategy_fbt'),
        requires: ['product'],
        pages_restricted: ['product_listing']
      },
      {
        id: "viewed_together",
        name: i18n.t('personalizations.experience_variable_strategy_viewed_together'),
        requires: ['product'],
        pages_restricted: ['checkout', 'category','home','product_listing','search']
      },
      // "purchased_together" (Comprados juntos) no se lista: en discover es un alias
      // de fbt (misma rama, mismos pares). Las configs guardadas con ese id siguen andando.
      {
        // Necesita un producto o carrito como semilla.
        id: "viewed_then_bought",
        name: i18n.t('personalizations.experience_variable_strategy_viewed_then_bought'),
        requires: ['product'],
        pages_restricted: ['checkout', 'category','home','product_listing','search','email']
      },
      {
        id: "popularity",
        name: i18n.t('personalizations.experience_variable_strategy_popularity')
      },
      {
        id: "recently_viewed",
        name: i18n.t('personalizations.experience_variable_strategy_recently_viewed'),
        requires: ['customer'],
      },
      {
        id: "recently_viewed_similar",
        name: i18n.t('personalizations.experience_variable_strategy_recently_viewed_similar'),
        uses: ['customer'],
      },
      {
        id: "liked_similar",
        name: i18n.t('personalizations.experience_variable_strategy_liked_similar'),
        requires: ['customer'],
      },
      {
        id: "recently_purchased_similar",
        name: i18n.t('personalizations.experience_variable_strategy_recently_purchased_similar'),
        requires: ['customer'],
      },
      {
        id: "user_affinity",
        name: i18n.t('personalizations.experience_variable_strategy_user_affinity'),
        uses: ['customer'],
        params: ['affinity'],
      },
      {
        id: "user_affinity_v2",
        name: "Afinidad v2",
        uses: ['customer'],
      },
      {
        id: "top-sellers",
        name: i18n.t('personalizations.experience_variable_strategy_top_sellers'),
      },
      {
        id: "most-viewed",
        name: i18n.t('personalizations.experience_variable_strategy_most_viewed'),
      },
      {
        id: "most_added_to_cart",
        name: i18n.t('personalizations.experience_variable_strategy_most_added_to_cart'),
      },
      {
        id: "trending",
        name: i18n.t('personalizations.experience_variable_strategy_trending'),
      },
      {
        id: "new_arrivals",
        name: i18n.t('personalizations.experience_variable_strategy_new_arrivals'),
      },
      {
        id: "last_viewed_category",
        name: i18n.t('personalizations.experience_variable_strategy_last_category_viewed'),
        requires: ['customer'],
      },
      {
        id: "popularity_category",
        name: i18n.t('personalizations.experience_variable_strategy_category_popularity'),
        requires: ['product'],
        pages_restricted: ['cart','checkout','home','product_listing','search']
      },
      {
        id: "recently_searched_similar",
        name: i18n.t('personalizations.experience_variable_strategy_recently_searched_similar'),
        requires: ['customer'],
      },
      {
        id: "recently_searched_popular",
        name: i18n.t('personalizations.experience_variable_strategy_recently_searched_popular'),
        requires: ['customer'],
      },
      {
        id: "recently_searched_user_reco",
        name: i18n.t('personalizations.experience_variable_strategy_recently_searched_user_reco'),
        requires: ['customer'],
      },
      {
        id: "top_searched_products",
        name: i18n.t('personalizations.experience_variable_strategy_top_searched_products'),
      },
      {
        // Usa la búsqueda de la página o la última búsqueda del cliente.
        id: "searched_then_bought",
        name: i18n.t('personalizations.experience_variable_strategy_searched_then_bought'),
        uses: ['customer'],
        params: ['term'],
        pages_restricted: ['product_detail','cart','checkout','category','product_listing']
      },
      {
        id: "semantic_search",
        name: "Semantic Search",
        params: ['term'],
      },
      
    ]
  },
  
  // eslint-disable-next-line no-unused-vars
  getFonts({commit}){
    return [
      {
        label: 'Alex Brush',
        value: 'Alex Brush',
        url: 'https://fonts.googleapis.com/css2?family=Alex+Brush&display=swap'
      },
      {
        label: "Andale Mono",
        value: "andale mono,times"
      },
      {
        label: 'Anton',
        value: 'Anton',
        url: 'https://fonts.googleapis.com/css2?family=Anton&display=swap'
      },
      {
        label: "Arial",
        value: "arial,helvetica,sans-serif"
      },
      {
        label: "Arial Black",
        value: "arial black,avant garde,arial"
      },
      {
        label: 'Arvo',
        value: 'Arvo',
        url: 'https://fonts.googleapis.com/css2?family=Arvo&display=swap'
      },
      {
        label: 'Bitter',
        value: 'Bitter',
        url: 'https://fonts.googleapis.com/css2?family=Bitter:wght@600&display=swap'
      },
      {
        label: "Book Antiqua",
        value: "book antiqua,palatino"
      },
      {
        label: 'Bungee',
        value: 'Bungee',
        url: 'https://fonts.googleapis.com/css2?family=Bungee&display=swap'
      },
      {
        label: 'Cabin',
        value: 'Cabin',
        url: 'https://fonts.googleapis.com/css?family=Cabin:400,700&display=swap'
      },
      {
        label: 'Caveat Brush',
        value: 'Caveat Brush',
        url: 'https://fonts.googleapis.com/css2?family=Caveat+Brush&display=swap'
      },
      {
        label: 'Chau Philomene One',
        value: 'Chau Philomene One',
        url: 'https://fonts.googleapis.com/css2?family=Chau+Philomene+One&display=swap'
      },
      {
        label: 'Cinzel Decorative',
        value: 'Cinzel Decorative',
        url: 'https://fonts.googleapis.com/css2?family=Cinzel+Decorative&display=swap'
      },
      {
        label: "Comic Sans MS",
        value: "comic sans ms,sans-serif"
      },
      {
        label: "Courier New",
        value: "courier new,courier"
      },
      {
        label: 'Crimson Text',
        value: 'Crimson Text',
        url: 'https://fonts.googleapis.com/css?family=Crimson+Text:400,700&display=swap'
      },
      {
        label: 'Epilogue',
        value: 'Epilogue',
        url: 'https://fonts.googleapis.com/css2?family=Epilogue:wght@500&display=swap'
      },
      {
        label: 'Federo',
        value: 'Federo',
        url: 'https://fonts.googleapis.com/css2?family=Federo&display=swap'
      },
      {
        label: 'Fredoka One',
        value: 'Fredoka One',
        url: 'https://fonts.googleapis.com/css2?family=Fredoka+One&display=swap'
      },
      {
        label: "Georgia",
        value: "georgia,palatino"
      },
      {
        label: 'Great Vibes',
        value: 'Great Vibes',
        url: 'https://fonts.googleapis.com/css2?family=Great+Vibes&display=swap'
      },
      {
        label: "Impact",
        value: "impact,chicago"
      },
      {
        label: 'Inter',
        value: 'Inter',
        url: 'https://fonts.googleapis.com/css2?family=Inter:wght@400;700&display=swap'
      },
      {
        label: "Helvetica",
        value: "helvetica,sans-serif"
      },
      {
        label: 'Lato',
        value: 'Lato',
        url: "https://fonts.googleapis.com/css?family=Lato:400,700&display=swap"
      },
      {
        label: 'Lobster Two',
        value: 'Lobster Two',
        url: "https://fonts.googleapis.com/css?family=Lobster+Two:400,700&display=swap"
      },
      {
        label: 'Montserrat',
        value: 'Montserrat',
        url: "https://fonts.googleapis.com/css?family=Montserrat:400,700&display=swap"
      },
      {
        label: 'Nunito',
        value: 'Nunito',
        url: "https://fonts.googleapis.com/css2?family=Nunito:wght@300&display=swap"
      },
      {
        label: 'Old Standard TT',
        value: 'Old Standard TT',
        url: "https://fonts.googleapis.com/css?family=Old+Standard+TT:400,700&display=swap"
      },
      {
        label: 'Open Sans',
        value: 'Open Sans',
        url: "https://fonts.googleapis.com/css?family=Open+Sans:400,700&display=swap"
      },
      {
        label: 'Oswald',
        value: 'Oswald',
        url: "https://fonts.googleapis.com/css2?family=Oswald:wght@300&display=swap"
      },
      {
        label: 'Pacifico',
        value: 'Pacifico',
        url: "https://fonts.googleapis.com/css?family=Pacifico&display=swap"
      },
      {
        label: 'Playfair Display',
        value: 'Playfair Display',
        url: 'https://fonts.googleapis.com/css?family=Playfair+Display:400,700&display=swap'
      },
      {
        label: 'Quicksand',
        value: 'Quicksand',
        url: "https://fonts.googleapis.com/css2?family=Quicksand:wght@700&display=swap"
      },
      {
        label: 'Raleway',
        value: 'Raleway',
        url: "https://fonts.googleapis.com/css?family=Raleway:400,700&display=swap"
      },
      {
        label: 'Roboto',
        value: 'Roboto',
        url: "https://fonts.googleapis.com/css2?family=Roboto:wght@400;700&display=swap"
      },
      
      {
        label: 'Rubik',
        value: 'Rubik',
        url: "https://fonts.googleapis.com/css?family=Rubik:400,700&display=swap"
      },
      {
        label: 'Source Sans Pro',
        value: 'Source Sans Pro',
        url: "https://fonts.googleapis.com/css?family=Source+Sans+Pro:400,700&display=swap"
      },
      {
        label: "Symbol",
        value: "symbol"
      },
      {
        label: "Tahoma",
        value: "tahoma,arial,helvetica,sans-serif"
      },
      {
        label: "Terminal",
        value: "terminal,monaco"
      },
      {
        label: "Times New Roman",
        value: "times new roman,times"
      },
      {
        label: "Trebuchet MS",
        value: "trebuchet ms,geneva"
      },
      {
        label: 'Ubuntu',
        value: 'Ubuntu',
        url: "https://fonts.googleapis.com/css2?family=Ubuntu:wght@300&display=swap"
      },
      {
        label: "Verdana",
        value: "verdana,geneva"
      },
    ]
  },

  // eslint-disable-next-line no-unused-vars
  getProductProperties({commit},params){
    return[
      {
        type : 'any',
        name: i18n.t('journeys.journey_workflow_components_wait_interaction_any'),
        column_name: 'any'
      },
      {
        type : 'text',
        name: "ID",
        column_name: 'id'
      },
      {
        type : 'text',
        name: i18n.t("items.sku"),
        column_name: 'sku'
      },
      {
        type : 'text',
        name: i18n.t("items.name"),
        column_name: 'name'
      },
      {
        type : 'text',
        name: i18n.t("items.description"),
        column_name: 'description'
      },
      {
        type : 'product_price',
        name: i18n.t("items.price"),
        column_name: 'product_price'
      },
      {
        type : 'product_category',
        name: i18n.t("items.category"),
        column_name: 'product_category'
      },
      {
        type : 'text',
        name: i18n.t("items.brand"),
        column_name: 'brand'
      },


    ]
  },

  // eslint-disable-next-line no-unused-vars
  getProductPropertiesOffline({commit},params){
    return[
      {
        type : 'any',
        name: i18n.t('journeys.journey_workflow_components_wait_interaction_any'),
        column_name: 'any'
      },
      {
        type : 'source',
        name: i18n.t("audiences.audience_conditions_product_field_source"),
        column_name: 'source'
      },
      {
        type : 'text',
        name: "ID",
        column_name: 'id'
      },
      {
        type : 'text',
        name: i18n.t("items.sku"),
        column_name: 'sku'
      },
      {
        type : 'text',
        name: i18n.t("items.name"),
        column_name: 'name'
      },
      {
        type : 'product_price',
        name: i18n.t("items.price"),
        column_name: 'product_price'
      },
      {
        type : 'product_category',
        name: i18n.t("items.category"),
        column_name: 'product_category'
      },
      {
        type : 'brand',
        name: i18n.t("items.brand"),
        column_name: 'brand'
      },
      {
        type : 'payment_method',
        name: i18n.t("audiences.audience_conditions_product_field_payment_method"),
        column_name: 'payment_method'
      },
    ]
  },

  // eslint-disable-next-line no-unused-vars
  getAudienceFields({commit}){
    let fields = [
      {
        group: i18n.t("audiences.audience_conditions_group_visit_behavior"),
        tooltip: i18n.t("audiences.audience_conditions_tooltip_group_visit_behavior"),
        icon:'mdi mdi-cursor-pointer',
        values:[
          //{ label: i18n.t("audiences.audience_conditions_fields_pages_visited"), value:'pages_viewed'},
          //{ label: i18n.t("audiences.audience_conditions_fields_url_visit"), value:'visit_url'},
          { label: i18n.t("audiences.audience_conditions_fields_added_to_cart"), value:'added_to_cart'},
          // { label: i18n.t("audiences.audience_conditions_fields_added_to_like"), value:'added_to_like'},
          
          //{ label: 'Cantidad de sesiones'},
        ],
      },
      {
        group: i18n.t("audiences.audience_conditions_group_purchase_behavior"),
        tooltip: i18n.t("audiences.audience_conditions_tooltip_group_purchase_behavior"),
        icon: 'mdi mdi-cart',
        values:[
          { label: i18n.t("audiences.audience_conditions_fields_purchases"), value: 'purchases'},
          //{ label: i18n.t("audiences.audience_conditions_fields_purchase_value"), value: 'purchase_value'},

          //{ label: 'AOV'},
          //{ label: 'Fecha ultima compra'},
          //{ label: 'Monto ultima compra'},
        ]
      },
      {
        group: i18n.t("audiences.audience_conditions_group_purchase_behavior_offline"),
        tooltip: i18n.t("audiences.audience_conditions_tooltip_group_purchase_behavior_offline"),
        icon: 'mdi mdi-storefront',
        values:[
          { label: i18n.t("audiences.audience_conditions_fields_purchases"), value: 'purchases_offline'},
          { label: i18n.t("audiences.audience_conditions_fields_interaction_purchase_offline"), value: 'interaction_purchase_offline'},
        ]
      },
      {
        group: i18n.t("audiences.audience_conditions_fields_affinity"),
        tooltip: i18n.t("audiences.audience_conditions_tooltip_group_affinity"),
        icon: 'mdi mdi-account-heart',
        value: 'affinity'
      },
      {
        group: i18n.t("audiences.audience_conditions_group_predictive"),
        tooltip: i18n.t("audiences.audience_conditions_tooltip_group_predictive"),
        icon:"mdi mdi-crystal-ball",
        values:[
          { label: i18n.t("audiences.audience_conditions_fields_likehood_purchase"), value: 'likehood_purchase'},
          { label: i18n.t("audiences.audience_conditions_fields_customer_cycle_status"), value: 'customer_cycle_status'},
        ]
      },
      {
        group: i18n.t("audiences.audience_conditions_fields_customer_properties"),
        tooltip: i18n.t("audiences.audience_conditions_tooltip_group_customer_properties"),
        icon:"mdi mdi-database",
        value: 'customer_field'
      },
      {
        group: i18n.t("audiences.audience_conditions_group_channel_reachability"),
        tooltip: i18n.t("audiences.audience_conditions_tooltip_group_channel_reachability"),
        icon:"mdi mdi-access-point-network",
        value: "channel_reachability"
      },
      {
        group: 'Cluster RFM (Online)',
        tooltip: i18n.t("audiences.audience_conditions_tooltip_group_cluster_rfm"),
        icon:'mdi mdi-account-cash',
        value: 'cluster_rfm'
      },
      {
        group: i18n.t("audiences.audience_conditions_group_contact_list"),
        tooltip: i18n.t("audiences.audience_conditions_tooltip_group_contact_list"),
        icon:'mdi mdi-book-account-outline',
        value: 'contact_lists'
      },
      {
        group:  i18n.t("audiences.audience_conditions_group_interactions"),
        tooltip: i18n.t("audiences.audience_conditions_tooltip_group_interactions"),
        icon:'mdi mdi-gesture-tap',
        values:[
          { label: i18n.t("audiences.audience_conditions_fields_interaction_purchase"), value: 'interaction_purchase'},
          { label: i18n.t("audiences.audience_conditions_fields_interaction_cart"), value: 'interaction_cart'},
          // { label: i18n.t("audiences.audience_conditions_fields_interaction_like"), value: 'interaction_like'},
          { label: i18n.t("audiences.audience_conditions_fields_interaction_view"), value: 'interaction_view'},
        ]
      },
      {
        group: i18n.t('audiences.audience_conditions_group_custom_interactions'),
        tooltip: i18n.t("audiences.audience_conditions_tooltip_group_custom_interactions"),
        icon:'mdi mdi-flash-circle',
        id: 'custom_interactions',
        values:[]
      },
      {
        group: i18n.t("audiences.audience_conditions_interaction_channel_group"),
        tooltip: i18n.t("audiences.audience_conditions_tooltip_group_interaction_channel_group"),
        icon:"mdi mdi-message-flash",
        values: [
          {
            label: i18n.t("audiences.audience_conditions_interaction_channel_purchase"),
            value: "purchase_channel_engagement",
          },
          {
            label: i18n.t("audiences.audience_conditions_interaction_channel_cart"),
            value: "cart_channel_engagement",
          },
          /*{
            label: i18n.t("audiences.audience_conditions_interaction_channel_like"),
            value: "like_channel_engagement",
          },*/
          {
            label: i18n.t("audiences.audience_conditions_interaction_channel_view"),
            value: "view_channel_engagement",
          },
          {
            label: i18n.t("audiences.audience_conditions_interaction_channel_purchase_offline"),
            value: "offline_channel_engagement",
          },
        ]
      },
      {
        group: i18n.t("audiences.audience_conditions_group_channel_engagement"),
        tooltip: i18n.t("audiences.audience_conditions_tooltip_group_channel_engagement"),
        icon:"mdi mdi-email-check",
        value: "channel_engagement"
      },
      {
        group: i18n.t("audiences.audience_conditions_group_notification_url_clicked"),
        tooltip: i18n.t("audiences.audience_conditions_tooltip_group_notification_url_clicked"),
        icon:"mdi mdi-link-variant",
        value: "notification_url_clicked"
      },
      {
        group: i18n.t("audiences.audience_conditions_group_journey_notification_url_clicked"),
        tooltip: i18n.t("audiences.audience_conditions_tooltip_group_journey_notification_url_clicked"),
        icon:"mdi mdi-link-variant",
        value: "journey_notification_url_clicked"
      },
      {
        group: "Live Shopping",
        tooltip: i18n.t("audiences.audience_conditions_tooltip_group_live_shopping"),
        icon:'mdi mdi-camera-front-variant',
        values:[
          { label: i18n.t("audiences.audience_conditions_fields_live_Shopping_invitations"), value: "live_shop_invitations_count"},
          { label: i18n.t("audiences.audience_conditions_fields_live_Shopping_events"), value: "live_shop_events_count"}
        ]
      },
      {
        group: 'Feedback',
        tooltip: i18n.t("audiences.audience_conditions_tooltip_group_feedback"),
        icon:"mdi mdi-star-half-full",
        values: [
          { label: i18n.t("audiences.audience_conditions_fields_feedback_simple"), value: 'feedback_simple' },
          { label: i18n.t("audiences.audience_conditions_fields_feedback_nps"), value: 'feedback_nps' },
        ]
      },
      {
        group: i18n.t("audiences.audience_conditions_group_searches"),
        tooltip: i18n.t("audiences.audience_conditions_tooltip_group_searches"),
        icon:'mdi mdi-magnify',
        values: [
          { label: i18n.t("audiences.audience_conditions_fields_search_count"), value: 'search_count' },
        ]
      }
      /*{
        group: i18n.t('audiences.audience_conditions_group_demographic'),
        icon:'mdi mdi-map-marker-radius',
        values:[
          { label: i18n.t("audiences.audience_conditions_fields_country"), value: "country"}
        ]
      },*/

      /*
      {
        group: 'Interacciones con canales'
      },
      {
        group: 'Otra Audiencia'
      },
      {
        group: 'Búsquedas'
      },
      {
        group: 'Live Shopping'
      },
      {
        group: 'Personalizaciones'
      },*/
    ]

    /* targetFields:[
      {
        group: this.$t("personalizations.experience_fields_group_session_behaviour"),
        values: [
          {
            label: this.$t("personalizations.experience_fields_new_customer"),
            value: "new_customer",
            operator: '=',
            term: {
              component: "boolean",
            }
          },
          {
            label: this.$t("personalizations.experience_fields_authenticated_customer"),
            value: "authenticated_customer",
            operator: '=',
            term: {
              component: "boolean",
            }
          },
          {
            label: this.$t("personalizations.experience_fields_pages_viewed"),
            value: "view_page",
            operator: '>',
            operators: [
              {"label" : this.$t("audiences.audience_conditions_bigger_than"), "id" : ">"},
              {"label" : this.$t("audiences.audience_conditions_less_than"), "id" : "<"},
              {"label" : this.$t("audiences.audience_conditions_equal"), "id" : "="},
            ],
            times:{
              "operator" : ">",
              "value": 1
            },
            term: {
              component: "input_num",
            }
          },
          {
            label: this.$t("personalizations.experience_fields_cart_count"),
            value: "cart_count",
            operator: '>',
            operators: [
              {"label" : this.$t("audiences.audience_conditions_bigger_than"), "id" : ">"},
              {"label" : this.$t("audiences.audience_conditions_less_than"), "id" : "<"},
              {"label" : this.$t("audiences.audience_conditions_equal"), "id" : "="},
            ],
            times:{
              "operator" : ">",
              "value": 1
            },
            term: {
              component: "input_num",
            }
          },
          {
            label: this.$t("personalizations.experience_fields_current_url"),
            value: "current_url",
            operator: 'like',
            term: {
              component: "text",
            }
          },
          {
            label: this.$t("personalizations.experience_fields_visit_url"),
            value: "visit_url",
            operator: 'like',
            term: {
              component: "text",
            }
          },
          {
            label: this.$t("personalizations.experience_fields_previous_page"),
            value: "previous_page",
            operator: 'like',
            term: {
              component: "text",
            }
          },
          {
            label: this.$t("personalizations.experience_fields_first_page"),
            value: "first_page",
            operator: 'like',
            term: {
              component: "text",
            }
          },
          {
            label: this.$t("personalizations.experience_fields_interaction_view"),
            value: "interaction_view",
            operator: '',
            term: {
              component: "products_component",
            }
          },
          {
            label: this.$t("personalizations.experience_fields_interaction_cart"),
            value: "interaction_cart",
            operator: '',
            term: {
              component: "products_component",
            }
          },
          {
            label: this.$t("personalizations.experience_fields_interaction_like"),
            value: "interaction_like",
            operator: '',
            term: {
              component: "products_component",
            }
          },
          {
            label: this.$t("personalizations.experience_fields_interaction_rate"),
            value: "interaction_rate",
            operator: '',
            term: {
              component: "products_component",
            }
          },
          {
            label: this.$t("personalizations.experience_fields_interaction_purchase"),
            value: "interaction_purchase",
            operator: '',
            term: {
              component: "products_component",
            }
          },
          {
            label: this.$t("audiences.audience_conditions_fields_affinity"),
            value: "affinity",
            operator: '',
            operatorsFields: [
              {"label" : this.$t("audiences.audience_conditions_affinity_highest"), "id" : "highest"},
              {"label" : "Top 3", "id" : "top_3"},
              {"label" : "Top 5", "id" : "top_5"},
              {"label" : "Top 10", "id" : "top_10"},
            ],
            term: {
              component: "affinity_page_component",
            }
          },
          
          
        ]
      },
      {
        group: 'Custom Interactions',
        id: 'custom_interactions',
        values: []
      },
      { group: this.$t("personalizations.experience_fields_group_customers"),
        values: [
          {
            label: this.$t("personalizations.experience_fields_audience"),
            value: "audience",
            operator: 'in',
            operators: [
              {"label" : this.$t("audiences.audience_conditions_belongs") , "id" : "in"},
              {"label" : this.$t("audiences.audience_conditions_not_belongs"), "id" : "not_in"},
            ],
            term: {
              component: "audiences_component",
            }
          },
        ]
      },
      {
        group: this.$t("audiences.audience_conditions_group_demographic"),
        values: [
          {
            label: this.$t("audiences.audience_conditions_fields_country"),
            value: "country",
            operator: 'in',
            term: {
              component: "country",
            }
          },
          {
            label:this.$t("personalizations.experience_fields_device"),
            value: "device",
            operator: '=',
            term: {
              component: "multiselect",
              values:[
              {
                id:0,
                label: "Mobile"
              },
              {
                id:1,
                label: "Desktop"
              }
              ]
            }
          },
          {
            label:this.$t("personalizations.experience_fields_weather"),
            value: "weather",
            operator: '=',
            term: {
              component: "multiselect",
              values:[
                {
                  id:0,
                  label: "rain"
                },
                {
                  id:1,
                  label: "clear"
                },
                {
                  id:3,
                  label: "clouds"
                },
                {
                  id:4,
                  label: "thunderstorm"
                },
                {
                  id:5,
                  label: "snow"
                },
                {
                  id:6,
                  label: "drizzle"
                },
                {
                  id:7,
                  label: "mist"
                },
                {
                  id:8,
                  label: "haze"
                },
                {
                  id:9,
                  label: "windy"
                },
                {
                  id:10,
                  label: "sunny"
                },
                {
                  id:11,
                  label: "partly_cloudy"
                },
                {
                  id:12,
                  label: "overcast"
                }
              ]
            }
          },
        ]
      },
      {
            group: this.$t("personalizations.experience_fields_group_time"),
            values: [
            {
              label: this.$t("personalizations.experience_fields_dates"),
              value: "dates",
              operator: 'in',
              operators: [
                {"label" : this.$t("personalizations.experience_fields_before") , "id" : "<"},
                {"label" :this.$t("personalizations.experience_fields_after") , "id" : ">"},
                {"label" : this.$t("personalizations.experience_fields_equal_date") , "id" : "="},
              ],
              term: {
                component: "dates_rage",
              }
            },
            {
              label: this.$t("personalizations.experience_fields_days"),
              value: "days",
              operator: 'in',
              term: {
                component: "multiselect",
                values: [
                  {
                    id:0,
                    label: this.$t("availability.availability_days_monday")
                  },
                  {
                    id:1,
                    label: this.$t("availability.availability_days_tuesday")
                  },
                  {
                    id:2,
                    label: this.$t("availability.availability_days_wednesday")
                  },
                  {
                    id:3,
                    label: this.$t("availability.availability_days_thursday")
                  },
                  {
                    id:4,
                    label: this.$t("availability.availability_days_friday")
                  },
                  {
                    id:5,
                    label: this.$t("availability.availability_days_saturday")
                  },
                  {
                    id:6,
                    label: this.$t("availability.availability_days_sunday")
                  },
                ]
              }
            },
            {
              label:this.$t("personalizations.experience_fields_hours"),
              value: "hours",
              operator: 'in',
              term: {
                component: "multiselect",
                values: [
                  {
                    id:0,
                    label: this.$t("personalizations.experience_fields_hours_morning")
                  },
                  {
                    id:1,
                    label: this.$t("personalizations.experience_fields_hours_afternoon")
                  },
                  {
                    id:2,
                    label: this.$t("personalizations.experience_fields_hours_night")
                  },
                ]
              }
            }
            ]
          }
    ]*/

          

          return fields;
  },
  // eslint-disable-next-line no-unused-vars
  getAudienceFieldsImplementation({commit}){
    let fields = [
      {
        group: i18n.t("audiences.audience_conditions_group_behaviours"),
        values: [
          /*{
            label: i18n.t("audiences.audience_conditions_fields_pages_visited"),
            value: "pages_viewed",
            operator: 'in',
            operators: [
              {"label" : i18n.t("audiences.audience_conditions_bigger_than"), "id" : ">"},
              {"label" : i18n.t("audiences.audience_conditions_less_than"), "id" : "<"},
              {"label" : i18n.t("audiences.audience_conditions_equal"), "id" : "="},
            ],
            times:{
              "operator" : ">",
              "value": 1
            },
            term: {
              component: "view_page_component",
              value: 'pages_viewed_count',
            }
          },*/
          /*{
            label: i18n.t("audiences.audience_conditions_fields_url_visit"),
            value: "visit_url",
            operator: 'like',
            operatorsFields: [
              {"label" : i18n.t("audiences.audience_conditions_contains"), "id" : "like"},
              {"label" : i18n.t("audiences.audience_conditions_no_contains"), "id" : "not_like"},
            ],
            operators: [
              {"label" : i18n.t("audiences.audience_conditions_bigger_than"), "id" : ">"},
              {"label" : i18n.t("audiences.audience_conditions_less_than"), "id" : "<"},
              {"label" : i18n.t("audiences.audience_conditions_equal"), "id" : "="},
            ],
            times:{
              "operator" : ">",
              "value": 1
            },
            term: {
              component: "visit_url",
              value: 'visit_url',
            }
          },*/
          {
            label: i18n.t("audiences.audience_conditions_fields_added_to_cart"),
            value: "added_to_cart",
            icon: 'mdi-cursor-pointer',
            tooltip: i18n.t("audiences.audience_conditions_tooltip_fields_added_to_cart"),
            operator: '',
            operators: [
              {"label" : i18n.t("audiences.audience_conditions_bigger_than2"), "id" : ">="},
              {"label" : i18n.t("audiences.audience_conditions_bigger_than"), "id" : ">"},
              {"label" : i18n.t("audiences.audience_conditions_less_than"), "id" : "<"},
              {"label" : i18n.t("audiences.audience_conditions_less_than2"), "id" : "<="},
              {"label" : i18n.t("audiences.audience_conditions_equal"), "id" : "="},
              {"label" : i18n.t("audiences.audience_conditions_not_equal"), "id" : "!="},
            ],
            times:{
              "operator" : ">=",
              "value": 1
            },
            term: {
              component: "input_num",
              value: 'added_to_cart_count',
            }
          },
          /*{
            label: i18n.t("audiences.audience_conditions_fields_added_to_like"),
            value: "added_to_like",
            operator: '' ,
            operators: [
              {"label" : i18n.t("audiences.audience_conditions_bigger_than"), "id" : ">"},
              {"label" : i18n.t("audiences.audience_conditions_less_than"), "id" : "<"},
              {"label" : i18n.t("audiences.audience_conditions_equal"), "id" : "="},
            ],
            times:{
              "operator" : ">",
              "value": 1
            },
            term: {
              component: "input_num",
            }
          },*/
          {
            label: i18n.t("audiences.audience_conditions_fields_purchases"),
            value: "purchases",
            icon: 'mdi mdi-cart',
            tooltip: i18n.t("audiences.audience_conditions_tooltip_fields_purchases"),
            operator: '',
            operators: [
              {"label" : i18n.t("audiences.audience_conditions_bigger_than2"), "id" : ">="},
              {"label" : i18n.t("audiences.audience_conditions_bigger_than"), "id" : ">"},
              {"label" : i18n.t("audiences.audience_conditions_less_than"), "id" : "<"},
              {"label" : i18n.t("audiences.audience_conditions_less_than2"), "id" : "<="},
              {"label" : i18n.t("audiences.audience_conditions_equal"), "id" : "="},
              {"label" : i18n.t("audiences.audience_conditions_not_equal"), "id" : "!="},
            ],
            times:{
              "operator" : ">=",
              "value": 1
            },
            term: {
              component: "input_num",
            }
          },
          {
            label: i18n.t("audiences.audience_conditions_fields_purchases"),
            value: "purchases_offline",
            icon: 'mdi mdi-storefront',
            tooltip: i18n.t("audiences.audience_conditions_tooltip_group_purchase_behavior_offline"),
            operator: '',
            operators: [
              {"label" : i18n.t("audiences.audience_conditions_bigger_than2"), "id" : ">="},
              {"label" : i18n.t("audiences.audience_conditions_bigger_than"), "id" : ">"},
              {"label" : i18n.t("audiences.audience_conditions_less_than"), "id" : "<"},
              {"label" : i18n.t("audiences.audience_conditions_less_than2"), "id" : "<="},
              {"label" : i18n.t("audiences.audience_conditions_equal"), "id" : "="},
              {"label" : i18n.t("audiences.audience_conditions_not_equal"), "id" : "!="},
            ],
            times:{
              "operator" : ">=",
              "value": 1
            },
            term: {
              component: "input_num",
            }
          },
          /*{
            label: i18n.t("audiences.audience_conditions_fields_purchase_value"),
            value: "purchase_value",
            operator: '>' ,
            operatorsFields: [
              {"label" : i18n.t("audiences.audience_conditions_bigger_than2"), "id" : ">"},
              {"label" : i18n.t("audiences.audience_conditions_less_than2"), "id" : "<"},
              {"label" : i18n.t("audiences.audience_conditions_equal"), "id" : "="},
            ],
            operators: [
              {"label" : i18n.t("audiences.audience_conditions_bigger_than"), "id" : ">"},
              {"label" : i18n.t("audiences.audience_conditions_less_than"), "id" : "<"},
              {"label" : i18n.t("audiences.audience_conditions_equal"), "id" : "="},
            ],
            times:{
              "operator" : ">",
              "value": 1
            },
            term: {
              component: "purchase_value",
              value: 'purchase_value',
            }
          },*/
          
          {
            label: "Cluster RFM (Online)",
            value: "cluster_rfm",
            operator: 'in',
            term: {
              component: "rfm_component",
            }
          },
          {
            label: i18n.t("audiences.audience_conditions_group_contact_list"),
            value: "contact_lists",
            operator: 'in',
            term: {
              component: "contact_list_component",
            }
          },
          {
            label: i18n.t("audiences.audience_conditions_fields_customer_properties"),
            value: "customer_field",
            operator: '',
            term: {
              component: "customer_page_component",
            }
          },
        ]
      },
      {
        group: i18n.t("audiences.audience_conditions_group_predictive"),
        values: [
          {
            label: i18n.t("audiences.audience_conditions_fields_affinity"),
            icon: 'mdi mdi-account-heart',
            tooltip: i18n.t("audiences.audience_conditions_tooltip_fields_affinity"),
            value: "affinity",
            operator: '',
            operatorsFields: [
              {"label" : i18n.t("audiences.audience_conditions_affinity_highest"), "id" : "highest"},
              {"label" : "Top 3", "id" : "top_3"},
              {"label" : "Top 5", "id" : "top_5"},
              {"label" : "Top 10", "id" : "top_10"},
            ],
            term: {
              component: "affinity_page_component",
            }
          },
          {
            label: i18n.t("audiences.audience_conditions_fields_likehood_purchase"),
            value: "likehood_purchase",
            icon: 'mdi mdi-crystal-ball',
            tooltip: i18n.t("audiences.audience_conditions_tooltip_fields_likehood_purchase"),
            operator: '=',
            term: {
              component: "likehood_component",
            }
          },
          {
            label: i18n.t("audiences.audience_conditions_fields_customer_cycle_status"),
            value: "customer_cycle_status",
            icon: 'mdi mdi-crystal-ball',
            tooltip: i18n.t("audiences.audience_conditions_tooltip_fields_customer_cycle_status"),
            operator: '=',
            term: {
              component: "lifecycle_component",
            }
          },
        ]
      },
      {
        group: i18n.t("audiences.audience_conditions_group_channel_reachability"),  
        values: [
          { 
            label: i18n.t("audiences.audience_conditions_group_channel_reachability"),
            value: "channel_reachability",
            icon: 'mdi mdi-access-point-network',
            tooltip: i18n.t("audiences.audience_conditions_tooltip_fields_channel_reachability"),
            operator: 'reachable',
            term: {
              component: "channel_reachability_component",
            }
          },
        ]
      },
      { group: i18n.t("audiences.audience_conditions_group_interactions"),
        id: 'interactions',
        values: [
          {
            label: i18n.t("audiences.audience_conditions_fields_interaction_view"),
            value: "interaction_view",
            icon: 'mdi mdi-gesture-tap',
            tooltip: i18n.t("audiences.audience_conditions_tooltip_fields_interaction_view"),
            operator: '',
            term: {
              component: "products_component",
              value: 'products_condition',
            }
          },
          {
            label: i18n.t("audiences.audience_conditions_fields_interaction_cart"),
            value: "interaction_cart",
            icon: 'mdi mdi-gesture-tap',
            tooltip: i18n.t("audiences.audience_conditions_tooltip_fields_interaction_cart"),
            operator: '',
            term: {
              component: "products_component",
              value: 'products_condition',
            }
          },
          /*{
            label: this.$t("audiences.audience_conditions_fields_interaction_rate"),
            value: "interaction_rate",
            icon: 'mdi mdi-gesture-tap',
            tooltip: i18n.t("audiences.audience_conditions_tooltip_fields_interaction_rate"),
            operator: '',
            term: {
              component: "products_component",
              value: 'products_condition',
            }
          },*/
          /*{
            label: i18n.t("audiences.audience_conditions_fields_interaction_like"),
            value: "interaction_like",
            icon: 'mdi mdi-gesture-tap',
            tooltip: i18n.t("audiences.audience_conditions_tooltip_fields_interaction_like"),
            operator: '',
            term: {
              component: "products_component",
              value: 'products_condition',
            }
          },*/
          {
            label: i18n.t("audiences.audience_conditions_fields_interaction_purchase"),
            value: "interaction_purchase",
            icon: 'mdi mdi-gesture-tap',
            tooltip: i18n.t("audiences.audience_conditions_tooltip_fields_interaction_purchase"),
            operator: '',
            term: {
              component: "products_component",
              value: 'products_condition',
            }
          },
          {
            label: i18n.t("audiences.audience_conditions_fields_interaction_purchase_offline"),
            value: "interaction_purchase_offline",
            icon: 'mdi mdi-storefront',
            tooltip: i18n.t("audiences.audience_conditions_tooltip_fields_interaction_purchase_offline"),
            operator: '',
            term: {
              component: "products_component",
              value: 'products_condition',
            }
          }],
      },
      {
        group: 'Custom Interactions',
        id: 'custom_interactions',
        icon: 'mdi mdi-flash-circle',
        tooltip: i18n.t("audiences.audience_conditions_tooltip_group_custom_interactions"),
        values: []
      },
      {
        group: "Live Shopping",
        values:[
          { 
            label: i18n.t("audiences.audience_conditions_fields_live_Shopping_invitations"),
            value: "live_shop_invitations_count",
            icon: 'mdi mdi-camera-front-variant',
            tooltip: i18n.t("audiences.audience_conditions_tooltip_fields_live_Shopping_invitations"),
            operator: '',
            term: {
              component: "live_shopping_component",
            }
          },
          { 
            label: i18n.t("audiences.audience_conditions_fields_live_Shopping_events"), 
            value: "live_shop_events_count",
            icon: 'mdi mdi-camera-front-variant',
            tooltip: i18n.t("audiences.audience_conditions_tooltip_fields_live_Shopping_events"),
            operator: '',
            term: {
              component: "live_shopping_component",
            }
          }
        ]
      },
      {
        group: 'Feedback',
        id: 'feedback',
        values: [
          { 
            label: i18n.t("audiences.audience_conditions_fields_feedback_simple"), 
            value: 'feedback_simple',
            icon: 'mdi mdi-star-half-full',
            tooltip: i18n.t("audiences.audience_conditions_tooltip_fields_feedback_simple"),
            operator: '',
            term: {
              component: "feedback_component",
              value: 'feedback_simple',
            }
          },
          { 
            label: i18n.t("audiences.audience_conditions_fields_feedback_nps"), 
            value: 'feedback_nps',
            icon: 'mdi mdi-star-half-full',
            tooltip: i18n.t("audiences.audience_conditions_tooltip_fields_feedback_nps"),
            operator: '',
            term: {
              component: "feedback_component",
              value: 'feedback_nps',
            }
          },
        ]
      },
      {
        group: i18n.t("audiences.audience_conditions_interaction_channel_group"),
        id: 'interaction_channel_engagement',
        values: [
          { 
            label: i18n.t("audiences.audience_conditions_interaction_channel_purchase"),
            value: 'purchase_channel_engagement',
            operator: '',
            term: {
              component: "interaction_channel_engagement_component",
            }
          },
          { 
            label: i18n.t("audiences.audience_conditions_interaction_channel_cart"),
            value: "cart_channel_engagement",
            operator: '',
            term: {
              component: "interaction_channel_engagement_component",
            }
          },
          /*{ 
            label: i18n.t("audiences.audience_conditions_interaction_channel_like"),
            value: "like_channel_engagement",
            operator: '',
            term: {
              component: "interaction_channel_engagement_component",
            }
          },*/
          { 
            label: i18n.t("audiences.audience_conditions_interaction_channel_view"),
            value: "view_channel_engagement",
            operator: '',
            term: {
              component: "interaction_channel_engagement_component",
            }
          },
          {
            label: i18n.t("audiences.audience_conditions_interaction_channel_purchase_offline"),
            value: "offline_channel_engagement",
            operator: '',
            term: {
              component: "interaction_channel_engagement_component",
            }
          },
        ]
      },
      {
        group: "Channel Engagement",
        id: 'channel_engagement',
        values: [
          {
            label: "Channel Engagement",
            value: "channel_engagement",
            operator: '',
            term: {
              component: "channel_engagement_component",
            }
          }
        ]
      },
      {
        group: i18n.t("audiences.audience_conditions_group_notification_url_clicked"),
        id: 'notification_url_clicked',
        values: [
          {
            label: i18n.t("audiences.audience_conditions_group_notification_url_clicked"),
            value: "notification_url_clicked",
            operator: 'clicked',
            term: {
              component: "notification_url_clicked_component",
            }
          }
        ]
          
        
      },
      {
        group: i18n.t("audiences.audience_conditions_group_journey_notification_url_clicked"),
        id: 'journey_notification_url_clicked',
        values: [
          {
            label: i18n.t("audiences.audience_conditions_group_journey_notification_url_clicked"),
            value: "journey_notification_url_clicked",
            operator: 'clicked',
            term: {
              component: "journey_notification_url_clicked_component",
            }
          }
        ]
      },
      {
        group: i18n.t("audiences.audience_conditions_group_searches"),
        id: 'searches',
        values: [
          {
            label: i18n.t("audiences.audience_conditions_fields_search_count"),
            value: "search_count",
            icon: 'mdi mdi-magnify',
            tooltip: i18n.t("audiences.audience_conditions_tooltip_fields_search_count"),
            operator: '',
            term: {
              component: "search_component",
            }
          }
        ]
      },
      /*{
        group: i18n.t("audiences.audience_conditions_group_demographic"),
        values: [
          {
            label: i18n.t("audiences.audience_conditions_fields_country"),
            value: "country",
            operator: 'in',
            term: {
              component: "country",
            }
          }
        ]
      },*/
    ]

    

    return fields;
  },

  // eslint-disable-next-line no-unused-vars
  getTargetFields({commit}){
    let fields = [
      {
        group: i18n.t("personalizations.experience_fields_group_session_behaviour"),
        icon:'mdi mdi-cursor-pointer',
        values:[
          { label: i18n.t("personalizations.experience_fields_new_customer"), value: "new_customer"},
          { label: i18n.t("personalizations.experience_fields_authenticated_customer"), value: "authenticated_customer"},
          // Oculto: ver `hidden` en getTargetFieldsImplementation.
          { label: i18n.t("personalizations.experience_fields_pages_viewed"), value: "view_page", hidden: true},
          { label: i18n.t("personalizations.experience_fields_current_url"), value: "current_url"},
          { label: i18n.t("personalizations.experience_fields_previous_page"), value: "previous_page"},
          { label: i18n.t("personalizations.experience_fields_first_page"), value: "first_page"},
          { label: i18n.t("personalizations.experience_fields_visit_url"), value: "visit_url"},
          { label: i18n.t("personalizations.experience_fields_cart_count"), value: "cart_count",},
          { label: i18n.t("personalizations.experience_fields_seen_content"), value: "seen_content"},

        ],
      },
      {
        group: i18n.t('personalizations.experience_fields_group_session_purchase_behaviour'),
        icon:'mdi mdi-cart',
        values:[
          { label: i18n.t("audiences.audience_conditions_fields_purchases"), value: 'purchases'},
          { label: i18n.t("audiences.audience_conditions_fields_purchase_value"), value: 'purchase_value'},
          { label: i18n.t("audiences.audience_conditions_fields_interaction_purchase"), value: 'interaction_purchase'},
        ],
      },
      {
        group: i18n.t('personalizations.experience_fields_group_session_interactions_behaviour'),
        icon:'mdi mdi-gesture-tap',
        values:[
          { label: i18n.t("audiences.audience_conditions_fields_interaction_purchase"), value: 'interaction_purchase'},
          { label: i18n.t("personalizations.experience_fields_interaction_cart"), value: 'interaction_cart'},
          { label: i18n.t("audiences.audience_conditions_fields_interaction_like"), value: 'interaction_like'},
          { label: i18n.t("audiences.audience_conditions_fields_interaction_view"), value: 'interaction_view'},
        ],
      },
      {
        group: i18n.t('personalizations.experience_fields_group_traffic'),
        icon:'mdi mdi-traffic-light',
        values:[
          { label: i18n.t("personalizations.experience_fields_traffic_source"), value: 'traffic_source'},
          { label: i18n.t("personalizations.experience_fields_source_url"), value: 'source_url'},
          { label: i18n.t("personalizations.experience_fields_utm"), value: 'utm'},
        ],
      },
      {
        group: i18n.t("audiences.audience_conditions_group_contact_list"),
        icon:'mdi mdi-book-account-outline',
        value: 'contact_lists'
      },
      {
        group:  i18n.t('personalizations.experience_fields_group_session_custom_interactions_behaviour'),
        icon:'mdi mdi-flash-circle',
        id: 'custom_interactions',
        values:[],
      },
      {
        group: i18n.t('personalizations.experience_fields_group_session_affinity'),
        icon:'mdi mdi-account-heart',
        value: 'affinity'
      },
      {
        group: i18n.t("personalizations.experience_fields_audience"),
        icon:'mdi mdi-account-group',
        value: 'audience'
      },
      {
        group: i18n.t('audiences.audience_conditions_group_demographic'),
        icon:'mdi mdi-map-marker-radius',
        values:[
          { label: i18n.t("audiences.audience_conditions_fields_country"), value: "country"},
          { label: i18n.t("audiences.audience_conditions_fields_city"), value: "city"}
        ]
      },
      {
        group: i18n.t("personalizations.experience_fields_weather"),
        icon:'mdi mdi-weather-cloudy',
        value: 'weather'
      },
      {
        group: i18n.t("personalizations.experience_fields_device"),
        icon:'mdi mdi-devices',
        value: 'device'
      },
      {
        group: i18n.t("personalizations.experience_fields_category"),
        icon:'mdi mdi-folder',
        value: 'category'
      },
      {
        group: i18n.t("personalizations.experience_fields_group_item_properties"),
        icon:'mdi mdi-package-variant',
        value: 'item_property'
      },
      {
        group: i18n.t("personalizations.experience_fields_item_time_interactions"),
        icon:'mdi mdi-chart-timeline-variant',
        value: 'item_time_interactions'
      },
      {
        group: i18n.t("personalizations.experience_fields_group_time"),
        icon:'mdi mdi-calendar',
        values:[
          { label: i18n.t("personalizations.experience_fields_dates"), value: "dates"},
          { label: i18n.t("personalizations.experience_fields_days"), value: "days"},
          { label: i18n.t("personalizations.experience_fields_hours"), value: "hours"},
          { label: i18n.t("personalizations.experience_fields_hours_min"), value: "hours_min"}
        ]
      },

    ]

    return fields;
  },

  // eslint-disable-next-line no-unused-vars
  getTargetFieldsImplementation({commit}){
    let fields = [
      {
        group: i18n.t("personalizations.experience_fields_group_session_behaviour"),
        values: [
          {
            label: i18n.t("personalizations.experience_fields_new_customer"),
            value: "new_customer",
            operator: '=',
            term: {
              component: "boolean",
            }
          },
          {
            label: i18n.t("personalizations.experience_fields_authenticated_customer"),
            value: "authenticated_customer",
            operator: '=',
            term: {
              component: "boolean",
            }
          },
          {
            label: i18n.t("personalizations.experience_fields_pages_viewed"),
            value: "view_page",
            // Oculto para condiciones nuevas: las páginas vistas por sesión no se
            // guardan en ningún lado que discover lea sin ir a Mongo. Queda la
            // definición para mostrar las reglas que ya existen.
            hidden: true,
            operator: '>',
            operators: [
              {"label" : i18n.t("audiences.audience_conditions_bigger_than"), "id" : ">"},
              {"label" : i18n.t("audiences.audience_conditions_less_than"), "id" : "<"},
              {"label" : i18n.t("audiences.audience_conditions_equal"), "id" : "="},
            ],
            times:{
              "operator" : ">",
              "value": 1
            },
            term: {
              component: "view_page_component",
            }
          },
          {
            label: i18n.t("personalizations.experience_fields_current_url"),
            value: "current_url",
            operator: 'like',
            operators: [
              {"label" : i18n.t("audiences.audience_conditions_contains"), "id" : "like"},
              {"label" : i18n.t("audiences.audience_conditions_no_contains"), "id" : "not_like"},
              ...multiValueTextOperators(),
            ],
            term: {
              component: "text",
            }
          },
          {
            label: i18n.t("personalizations.experience_fields_previous_page"),
            value: "previous_page",
            operator: 'like',
            operators: [
              {"label" : i18n.t("audiences.audience_conditions_contains"), "id" : "like"},
              {"label" : i18n.t("audiences.audience_conditions_no_contains"), "id" : "not_like"},
              ...multiValueTextOperators(),
            ],
            term: {
              component: "text",
            }
          },
          {
            label: i18n.t("personalizations.experience_fields_first_page"),
            value: "first_page",
            operator: 'like',
            operators: [
              {"label" : i18n.t("audiences.audience_conditions_contains"), "id" : "like"},
              {"label" : i18n.t("audiences.audience_conditions_no_contains"), "id" : "not_like"},
              ...multiValueTextOperators(),
            ],
            term: {
              component: "text",
            }
          },
          {
            label: i18n.t("personalizations.experience_fields_visit_url"),
            value: "visit_url",
            operator: 'like',
            operators: [
              {"label" : i18n.t("audiences.audience_conditions_contains"), "id" : "like"},
              {"label" : i18n.t("audiences.audience_conditions_no_contains"), "id" : "not_like"},
              ...multiValueTextOperators(),
            ],
            term: {
              component: "text",
            }
          },
          {
            label: i18n.t("personalizations.experience_fields_cart_count"),
            value: "cart_count",
            operator: '>',
            operators: [
              {"label" : i18n.t("audiences.audience_conditions_bigger_than"), "id" : ">"},
              {"label" : i18n.t("audiences.audience_conditions_less_than"), "id" : "<"},
              {"label" : i18n.t("audiences.audience_conditions_equal"), "id" : "="},
            ],
            times:{
              "operator" : ">",
              "value": 1
            },
            term: {
              component: "input_num",
            }
          },
          {
            // Personalizaciones ya servidas en la sesion (el SDK manda context.seenContents).
            // El termino se guarda como [{ _id, name, key }] igual que audiencias.
            label: i18n.t("personalizations.experience_fields_seen_content"),
            value: "seen_content",
            operator: 'in',
            operators: [
              {"label" : i18n.t("personalizations.experience_fields_seen_content_in"), "id" : "in"},
              {"label" : i18n.t("personalizations.experience_fields_seen_content_not_in"), "id" : "not_in"},
            ],
            term: {
              component: "contents_component",
            }
          },
        ]
      },
      {
        group: i18n.t('personalizations.experience_fields_group_session_purchase_behaviour'),
        values:[
        {
            label: i18n.t("audiences.audience_conditions_fields_purchase_value"),
            value: "purchase_value",
            operator: '>' ,
            // Etiquetas estrictas: discover evalúa > y < (antes decían "o igual").
            operatorsFields: [
              {"label" : i18n.t("audiences.audience_conditions_bigger_than"), "id" : ">"},
              {"label" : i18n.t("audiences.audience_conditions_less_than"), "id" : "<"},
              {"label" : i18n.t("audiences.audience_conditions_equal"), "id" : "="},
            ],
            operators: [
              {"label" : i18n.t("audiences.audience_conditions_bigger_than"), "id" : ">"},
              {"label" : i18n.t("audiences.audience_conditions_less_than"), "id" : "<"},
              {"label" : i18n.t("audiences.audience_conditions_equal"), "id" : "="},
            ],
            times:{
              "operator" : ">",
              "value": 1
            },
            term: {
              component: "purchase_value",
              value: 'purchase_value',
            }
          },
          {
            label: i18n.t("audiences.audience_conditions_fields_purchases"),
            value: "purchases",
            operator: '',
            operators: [
              {"label" : i18n.t("audiences.audience_conditions_bigger_than"), "id" : ">"},
              {"label" : i18n.t("audiences.audience_conditions_less_than"), "id" : "<"},
              {"label" : i18n.t("audiences.audience_conditions_equal"), "id" : "="},
            ],
            times:{
              "operator" : ">",
              "value": 1
            },
            term: {
              component: "input_num",
            }
          },
        ]
      },
      {
        group: i18n.t('personalizations.experience_fields_group_session_interactions_behaviour'),
        values:[
        {
            label: i18n.t("personalizations.experience_fields_interaction_view"),
            value: "interaction_view",
            operator: '',
            term: {
              component: "products_component",
            }
          },
          {
            label: i18n.t("personalizations.experience_fields_interaction_cart"),
            value: "interaction_cart",
            operator: '',
            term: {
              component: "products_component",
            }
          },
          {
            label: i18n.t("personalizations.experience_fields_interaction_like"),
            value: "interaction_like",
            operator: '',
            term: {
              component: "products_component",
            }
          },
          {
            label: i18n.t("personalizations.experience_fields_interaction_purchase"),
            value: "interaction_purchase",
            operator: '',
            term: {
              component: "products_component",
            }
          },
        ]
      },
      {
        group: i18n.t('personalizations.experience_fields_group_traffic'),
        values:[
          {
            label: i18n.t("personalizations.experience_fields_traffic_source"),
            value: "traffic_source",
            operator: '=',
            operators: [
              {"label" : i18n.t("personalizations.experience_fields_traffic_is"), "id" : "="},
              {"label" : i18n.t("personalizations.experience_fields_traffic_is_not"), "id" : "!="},
              {"label" : i18n.t("audiences.audience_conditions_belongs"), "id" : "in"},
              {"label" : i18n.t("audiences.audience_conditions_not_belongs"), "id" : "not_in"},
            ],
            term: {
              component: "traffic_source_component",
              values: [
                { id: 'direct', label: i18n.t("personalizations.experience_fields_traffic_source_direct") },
                { id: 'paid', label: i18n.t("personalizations.experience_fields_traffic_source_paid") },
                { id: 'search', label: i18n.t("personalizations.experience_fields_traffic_source_search") },
                { id: 'social', label: i18n.t("personalizations.experience_fields_traffic_source_social") },
              ]
            }
          },
          {
            label: i18n.t("personalizations.experience_fields_source_url"),
            value: "source_url",
            operator: 'like',
            operators: [
              {"label" : i18n.t("audiences.audience_conditions_equal"), "id" : "="},
              {"label" : i18n.t("audiences.audience_conditions_contains"), "id" : "like"},
              {"label" : i18n.t("audiences.audience_conditions_no_contains"), "id" : "not_like"},
              ...multiValueTextOperators(),
              {"label" : i18n.t("audiences.audience_conditions_not_empty"), "id" : "not_empty"},
              {"label" : i18n.t("audiences.audience_conditions_empty"), "id" : "empty"},
            ],
            term: {
              component: "source_url_component",
            }
          },
          {
            label: i18n.t("personalizations.experience_fields_utm"),
            value: "utm",
            operator: 'like',
            operators: [
              {"label" : i18n.t("audiences.audience_conditions_equal"), "id" : "="},
              {"label" : i18n.t("audiences.audience_conditions_contains"), "id" : "like"},
              {"label" : i18n.t("audiences.audience_conditions_no_contains"), "id" : "not_like"},
              ...multiValueTextOperators(),
              {"label" : i18n.t("audiences.audience_conditions_not_empty"), "id" : "not_empty"},
              {"label" : i18n.t("audiences.audience_conditions_empty"), "id" : "empty"},
            ],
            term: {
              component: "utm_component",
              values: [
                { id: 'utm_source', label: 'utm_source' },
                { id: 'utm_medium', label: 'utm_medium' },
                { id: 'utm_campaign', label: 'utm_campaign' },
                { id: 'utm_term', label: 'utm_term' },
                { id: 'utm_content', label: 'utm_content' },
              ]
            }
          },
        ]
      },
      {
        group: i18n.t('personalizations.experience_fields_group_session_custom_interactions_behaviour'),
        id: 'custom_interactions',
        values: []
      },
      {
        group: i18n.t('personalizations.experience_fields_group_item_properties'),
        values:[
        {
            label: i18n.t("personalizations.experience_fields_group_item_properties"),
            value: "item_property",
            operator: '',
            term: {
              component: "item_property_component",
            }
          },
        ]
      },
      {
        group: i18n.t('personalizations.experience_fields_item_time_interactions'),
        values: [
          {
            label: i18n.t('personalizations.experience_fields_item_time_interactions'),
            value: 'item_time_interactions',
            operators: [
              { id: '>', label: i18n.t('audiences.audience_conditions_bigger_than') },
              { id: '<', label: i18n.t('audiences.audience_conditions_less_than') },
              { id: '>=', label: i18n.t('audiences.audience_conditions_bigger_than2') },
              { id: '<=', label: i18n.t('audiences.audience_conditions_less_than2') },
              { id: '=', label: i18n.t('audiences.audience_conditions_equal') },
              { id: '!=', label: i18n.t('audiences.audience_conditions_not_equal') },
            ],
            defaultValue: {
              event: 'view',
              days: 7,
              times: {
                operator: '>=',
                value: 10,
              },
            },
            constraints: {
              days: { min: 1, max: 90 },
              times: { min: 0 },
            },
            term: {
              component: 'item_time_interactions_component',
              values: [
                { id: 'view', label: i18n.t('personalizations.interaction_view') },
                { id: 'cart', label: i18n.t('personalizations.interaction_cart') },
                { id: 'purchase', label: i18n.t('personalizations.interaction_purchase') },
              ],
            }
          },
        ]
      },
      {
        group: i18n.t('personalizations.experience_fields_group_session_affinity'),
        values:[
        {
            label: i18n.t("audiences.audience_conditions_fields_affinity"),
            value: "affinity",
            operator: '',
            operatorsFields: [
              {"label" : i18n.t("audiences.audience_conditions_affinity_highest"), "id" : "highest"},
              {"label" : "Top 3", "id" : "top_3"},
              {"label" : "Top 5", "id" : "top_5"},
              {"label" : "Top 10", "id" : "top_10"},
            ],
            term: {
              component: "affinity_page_component",
            }
          },
        ]
      },
      { group: i18n.t("personalizations.experience_fields_group_customers"),
        values: [
          {
            label: i18n.t("personalizations.experience_fields_audience"),
            value: "audience",
            operator: 'in',
            operators: [
              {"label" : i18n.t("audiences.audience_conditions_belongs") , "id" : "in"},
              {"label" : i18n.t("audiences.audience_conditions_not_belongs"), "id" : "not_in"},
            ],
            term: {
              component: "audiences_component",
            }
          },
          {
            label: i18n.t("audiences.audience_conditions_group_contact_list"),
            value: "contact_lists",
            operator: 'in',
            operators: [
              {"label" : i18n.t("audiences.audience_conditions_belongs") , "id" : "in"},
              {"label" : i18n.t("audiences.audience_conditions_not_belongs"), "id" : "not_in"},
            ],
            term: {
              component: "contact_list_component",
            }
          },
        ]
      },
      {
        group: i18n.t("audiences.audience_conditions_group_demographic"),
        values: [
          {
            label: i18n.t("audiences.audience_conditions_fields_country"),
            value: "country",
            operator: 'in',
            term: {
              component: "country",
            }
          },
          {
            label: i18n.t("audiences.audience_conditions_fields_city"),
            value: "city",
            operator: 'in',
            term: {
              component: "city",
            }
          },
        ]
      },
      {
        group: i18n.t("personalizations.experience_fields_weather"),
        values:[
        {
            label:i18n.t("personalizations.experience_fields_weather"),
            value: "weather",
            operator: '=',
            term: {
              component: "multiselect",
              values:[
                {
                  id:0,
                  label: "rain"
                },
                {
                  id:1,
                  label: "clear"
                },
                {
                  id:3,
                  label: "clouds"
                },
                {
                  id:4,
                  label: "thunderstorm"
                },
                {
                  id:5,
                  label: "snow"
                },
                {
                  id:6,
                  label: "drizzle"
                },
                {
                  id:7,
                  label: "mist"
                },
                {
                  id:8,
                  label: "haze"
                },
                {
                  id:9,
                  label: "windy"
                },
                {
                  id:10,
                  label: "sunny"
                },
                {
                  id:11,
                  label: "partly_cloudy"
                },
                {
                  id:12,
                  label: "overcast"
                }
              ]
            }
          },
        ]
      },
      {
        group: i18n.t("personalizations.experience_fields_device"),
        values: [
        {
            label:i18n.t("personalizations.experience_fields_device"),
            value: "device",
            operator: '=',
            term: {
              component: "multiselect",
              values:[
              {
                id:0,
                label: "Mobile"
              },
              {
                id:1,
                label: "Desktop"
              }
              ]
            }
          },
        ]
      },
      {
        group: i18n.t("personalizations.experience_fields_category"),
        values: [
        {
            label:i18n.t("personalizations.experience_fields_category"),
            value: "category",
            operator: 'like',
            operators: [
              {"label" : i18n.t("audiences.audience_conditions_contains"), "id" : "like"},
              {"label" : i18n.t("audiences.audience_conditions_no_contains"), "id" : "not_like"},
            ],
            term: {
              component: "text"
            }
          },
        ]
      },
      {
            group: i18n.t("personalizations.experience_fields_group_time"),
            values: [
            {
              label: i18n.t("personalizations.experience_fields_dates"),
              value: "dates",
              operator: 'in',
              operators: [
                {"label" : i18n.t("personalizations.experience_fields_before") , "id" : "<"},
                {"label" :i18n.t("personalizations.experience_fields_after") , "id" : ">"},
                {"label" : i18n.t("personalizations.experience_fields_equal_date") , "id" : "="},
              ],
              term: {
                component: "dates_rage",
              }
            },
            {
              label: i18n.t("personalizations.experience_fields_days"),
              value: "days",
              operator: 'in',
              term: {
                component: "multiselect",
                values: [
                  {
                    id:0,
                    label: i18n.t("availability.availability_days_monday")
                  },
                  {
                    id:1,
                    label: i18n.t("availability.availability_days_tuesday")
                  },
                  {
                    id:2,
                    label: i18n.t("availability.availability_days_wednesday")
                  },
                  {
                    id:3,
                    label: i18n.t("availability.availability_days_thursday")
                  },
                  {
                    id:4,
                    label: i18n.t("availability.availability_days_friday")
                  },
                  {
                    id:5,
                    label: i18n.t("availability.availability_days_saturday")
                  },
                  {
                    id:6,
                    label: i18n.t("availability.availability_days_sunday")
                  },
                ]
              }
            },
            {
              label:i18n.t("personalizations.experience_fields_hours"),
              value: "hours",
              operator: 'in',
              term: {
                component: "multiselect",
                values: [
                  {
                    id:0,
                    label: i18n.t("personalizations.experience_fields_hours_morning")
                  },
                  {
                    id:1,
                    label: i18n.t("personalizations.experience_fields_hours_afternoon")
                  },
                  {
                    id:2,
                    label: i18n.t("personalizations.experience_fields_hours_night")
                  },
                ]
              }
            },
            {
              label:i18n.t("personalizations.experience_fields_hours_min"),
              value: "hours_min",
              operator: 'in',
              term: {
                component: "hours_range",
              }
            }
            ]
          }
    ]

    return fields;
  },

  getAudienceSummary({ dispatch }, payload = {}) {
    const rules = payload?.rules ?? payload;
    const context = payload?.context || {};
    const project = sessionStorage.getItem('current_project');

    const loaders = {
      loadBroadcasts: () => dispatch('broadcasts/getBroadcasts', {
        q: `where[status]=finished&where[project]=${project}&limit=100&select=_id name`,
      }, { root: true }).then((response) => response?.data || []).catch(() => []),
      loadJourneys: () => dispatch('journeys/getJourneys', {
        q: `where[project]=${project}&limit=100&select=_id name`,
      }, { root: true }).then((response) => response?.data || []).catch(() => []),
    };

    return enrichAudienceSummaryContext(rules, context, loaders).then((enrichedContext) => (
      dispatch('getAudienceFieldsImplementation').then((fields) => {
        const fieldMap = buildAudienceFieldMap(fields);
        return getAudienceSummaryBullets(
          rules,
          fieldMap,
          enrichedContext,
          (key, params) => i18n.t(key, params),
        );
      })
    ));
  }
}
